import _ from "lodash";
import ACLStore from "lib/aclStore";

import {
  PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT,
  PROJECT_SUBTYPE_CORE,
} from "Constants/stringConstants";

import { getUserProjectGroupsFromCache } from "Projects/modules/ProjectGraphqlHelpers";

const getYearGroupCurriculumProgramFilterMemoized = _.memoize(
  curriculumProgramIds => {
    return !ACLStore.can("FeatureFlag:ShowAllYearGroupProjectGroups")
      ? {
          yearGroupCurriculumProgramIds: curriculumProgramIds,
        }
      : {};
  },
  JSON.stringify
);

export const getProjectGroupsFromCache = ({
  userInfo,
  curriculumProgramId,
  selectedAcademicYearId,
}) => {
  const curriculumProgramIds = [curriculumProgramId];

  const yearGroupCurriculumProgramFilter = getYearGroupCurriculumProgramFilterMemoized(
    curriculumProgramIds
  );

  const projectGroupSubTypeFilters = [
    PROJECT_SUBTYPE_CORE,
    PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT,
  ];

  const filters = {
    curriculumProgramIds,
    projectGroupSubTypes: projectGroupSubTypeFilters,
    ...yearGroupCurriculumProgramFilter,
    yearGroupArchivalState: "ALL",
    academicYears: [selectedAcademicYearId],
  };

  const variables = {
    id: userInfo?.id,
    type: userInfo?.userEntityType,
    filters,
  };

  const data = getUserProjectGroupsFromCache(variables);

  return _.get(data, "node.projectGroups", []);
};
